"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tridentRouterAbi = void 0;
exports.tridentRouterAbi = [
    {
        inputs: [
            {
                internalType: 'contract IBentoBoxMinimal',
                name: '_bento',
                type: 'address',
            },
            {
                internalType: 'contract IMasterDeployer',
                name: '_masterDeployer',
                type: 'address',
            },
            {
                internalType: 'address',
                name: '_wETH',
                type: 'address',
            },
        ],
        stateMutability: 'nonpayable',
        type: 'constructor',
    },
    {
        inputs: [],
        name: 'IncorrectSlippageParams',
        type: 'error',
    },
    {
        inputs: [],
        name: 'NotEnoughLiquidityMinted',
        type: 'error',
    },
    {
        inputs: [],
        name: 'NotWethSender',
        type: 'error',
    },
    {
        inputs: [],
        name: 'TooLittleReceived',
        type: 'error',
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: 'address',
                        name: 'token',
                        type: 'address',
                    },
                    {
                        internalType: 'bool',
                        name: 'native',
                        type: 'bool',
                    },
                    {
                        internalType: 'uint256',
                        name: 'amount',
                        type: 'uint256',
                    },
                ],
                internalType: 'struct ITridentRouter.TokenInput[]',
                name: 'tokenInput',
                type: 'tuple[]',
            },
            {
                internalType: 'address',
                name: 'pool',
                type: 'address',
            },
            {
                internalType: 'uint256',
                name: 'minLiquidity',
                type: 'uint256',
            },
            {
                internalType: 'bytes',
                name: 'data',
                type: 'bytes',
            },
        ],
        name: 'addLiquidity',
        outputs: [
            {
                internalType: 'uint256',
                name: 'liquidity',
                type: 'uint256',
            },
        ],
        stateMutability: 'payable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint8',
                name: 'v',
                type: 'uint8',
            },
            {
                internalType: 'bytes32',
                name: 'r',
                type: 'bytes32',
            },
            {
                internalType: 'bytes32',
                name: 's',
                type: 'bytes32',
            },
        ],
        name: 'approveMasterContract',
        outputs: [],
        stateMutability: 'payable',
        type: 'function',
    },
    {
        inputs: [],
        name: 'bento',
        outputs: [
            {
                internalType: 'contract IBentoBoxMinimal',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'pool',
                type: 'address',
            },
            {
                internalType: 'uint256',
                name: 'liquidity',
                type: 'uint256',
            },
            {
                internalType: 'bytes',
                name: 'data',
                type: 'bytes',
            },
            {
                components: [
                    {
                        internalType: 'address',
                        name: 'token',
                        type: 'address',
                    },
                    {
                        internalType: 'uint256',
                        name: 'amount',
                        type: 'uint256',
                    },
                ],
                internalType: 'struct IPool.TokenAmount[]',
                name: 'minWithdrawals',
                type: 'tuple[]',
            },
        ],
        name: 'burnLiquidity',
        outputs: [],
        stateMutability: 'payable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'pool',
                type: 'address',
            },
            {
                internalType: 'uint256',
                name: 'liquidity',
                type: 'uint256',
            },
            {
                internalType: 'bytes',
                name: 'data',
                type: 'bytes',
            },
            {
                internalType: 'uint256',
                name: 'minWithdrawal',
                type: 'uint256',
            },
        ],
        name: 'burnLiquiditySingle',
        outputs: [],
        stateMutability: 'payable',
        type: 'function',
    },
    {
        inputs: [
            {
                components: [
                    {
                        components: [
                            {
                                internalType: 'address',
                                name: 'tokenIn',
                                type: 'address',
                            },
                            {
                                internalType: 'address',
                                name: 'pool',
                                type: 'address',
                            },
                            {
                                internalType: 'bool',
                                name: 'native',
                                type: 'bool',
                            },
                            {
                                internalType: 'uint256',
                                name: 'amount',
                                type: 'uint256',
                            },
                            {
                                internalType: 'bytes',
                                name: 'data',
                                type: 'bytes',
                            },
                        ],
                        internalType: 'struct ITridentRouter.InitialPath[]',
                        name: 'initialPath',
                        type: 'tuple[]',
                    },
                    {
                        components: [
                            {
                                internalType: 'address',
                                name: 'tokenIn',
                                type: 'address',
                            },
                            {
                                internalType: 'address',
                                name: 'pool',
                                type: 'address',
                            },
                            {
                                internalType: 'uint64',
                                name: 'balancePercentage',
                                type: 'uint64',
                            },
                            {
                                internalType: 'bytes',
                                name: 'data',
                                type: 'bytes',
                            },
                        ],
                        internalType: 'struct ITridentRouter.PercentagePath[]',
                        name: 'percentagePath',
                        type: 'tuple[]',
                    },
                    {
                        components: [
                            {
                                internalType: 'address',
                                name: 'token',
                                type: 'address',
                            },
                            {
                                internalType: 'address',
                                name: 'to',
                                type: 'address',
                            },
                            {
                                internalType: 'bool',
                                name: 'unwrapBento',
                                type: 'bool',
                            },
                            {
                                internalType: 'uint256',
                                name: 'minAmount',
                                type: 'uint256',
                            },
                        ],
                        internalType: 'struct ITridentRouter.Output[]',
                        name: 'output',
                        type: 'tuple[]',
                    },
                ],
                internalType: 'struct ITridentRouter.ComplexPathParams',
                name: 'params',
                type: 'tuple',
            },
        ],
        name: 'complexPath',
        outputs: [],
        stateMutability: 'payable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'factory',
                type: 'address',
            },
            {
                internalType: 'bytes',
                name: 'deployData',
                type: 'bytes',
            },
        ],
        name: 'deployPool',
        outputs: [
            {
                internalType: 'address',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'payable',
        type: 'function',
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: 'address',
                        name: 'tokenIn',
                        type: 'address',
                    },
                    {
                        internalType: 'uint256',
                        name: 'amountIn',
                        type: 'uint256',
                    },
                    {
                        internalType: 'uint256',
                        name: 'amountOutMinimum',
                        type: 'uint256',
                    },
                    {
                        components: [
                            {
                                internalType: 'address',
                                name: 'pool',
                                type: 'address',
                            },
                            {
                                internalType: 'bytes',
                                name: 'data',
                                type: 'bytes',
                            },
                        ],
                        internalType: 'struct ITridentRouter.Path[]',
                        name: 'path',
                        type: 'tuple[]',
                    },
                ],
                internalType: 'struct ITridentRouter.ExactInputParams',
                name: 'params',
                type: 'tuple',
            },
        ],
        name: 'exactInput',
        outputs: [
            {
                internalType: 'uint256',
                name: 'amountOut',
                type: 'uint256',
            },
        ],
        stateMutability: 'payable',
        type: 'function',
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: 'uint256',
                        name: 'amountIn',
                        type: 'uint256',
                    },
                    {
                        internalType: 'uint256',
                        name: 'amountOutMinimum',
                        type: 'uint256',
                    },
                    {
                        internalType: 'address',
                        name: 'pool',
                        type: 'address',
                    },
                    {
                        internalType: 'address',
                        name: 'tokenIn',
                        type: 'address',
                    },
                    {
                        internalType: 'bytes',
                        name: 'data',
                        type: 'bytes',
                    },
                ],
                internalType: 'struct ITridentRouter.ExactInputSingleParams',
                name: 'params',
                type: 'tuple',
            },
        ],
        name: 'exactInputSingle',
        outputs: [
            {
                internalType: 'uint256',
                name: 'amountOut',
                type: 'uint256',
            },
        ],
        stateMutability: 'payable',
        type: 'function',
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: 'uint256',
                        name: 'amountIn',
                        type: 'uint256',
                    },
                    {
                        internalType: 'uint256',
                        name: 'amountOutMinimum',
                        type: 'uint256',
                    },
                    {
                        internalType: 'address',
                        name: 'pool',
                        type: 'address',
                    },
                    {
                        internalType: 'address',
                        name: 'tokenIn',
                        type: 'address',
                    },
                    {
                        internalType: 'bytes',
                        name: 'data',
                        type: 'bytes',
                    },
                ],
                internalType: 'struct ITridentRouter.ExactInputSingleParams',
                name: 'params',
                type: 'tuple',
            },
        ],
        name: 'exactInputSingleWithNativeToken',
        outputs: [
            {
                internalType: 'uint256',
                name: 'amountOut',
                type: 'uint256',
            },
        ],
        stateMutability: 'payable',
        type: 'function',
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: 'address',
                        name: 'tokenIn',
                        type: 'address',
                    },
                    {
                        internalType: 'uint256',
                        name: 'amountIn',
                        type: 'uint256',
                    },
                    {
                        internalType: 'uint256',
                        name: 'amountOutMinimum',
                        type: 'uint256',
                    },
                    {
                        components: [
                            {
                                internalType: 'address',
                                name: 'pool',
                                type: 'address',
                            },
                            {
                                internalType: 'bytes',
                                name: 'data',
                                type: 'bytes',
                            },
                        ],
                        internalType: 'struct ITridentRouter.Path[]',
                        name: 'path',
                        type: 'tuple[]',
                    },
                ],
                internalType: 'struct ITridentRouter.ExactInputParams',
                name: 'params',
                type: 'tuple',
            },
        ],
        name: 'exactInputWithNativeToken',
        outputs: [
            {
                internalType: 'uint256',
                name: 'amountOut',
                type: 'uint256',
            },
        ],
        stateMutability: 'payable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'token',
                type: 'address',
            },
            {
                internalType: 'uint256',
                name: 'maxChangeAmount',
                type: 'uint256',
            },
        ],
        name: 'harvest',
        outputs: [],
        stateMutability: 'payable',
        type: 'function',
    },
    {
        inputs: [],
        name: 'masterDeployer',
        outputs: [
            {
                internalType: 'contract IMasterDeployer',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'bytes[]',
                name: 'data',
                type: 'bytes[]',
            },
        ],
        name: 'multicall',
        outputs: [
            {
                internalType: 'bytes[]',
                name: 'results',
                type: 'bytes[]',
            },
        ],
        stateMutability: 'payable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'token',
                type: 'address',
            },
            {
                internalType: 'uint256',
                name: 'value',
                type: 'uint256',
            },
            {
                internalType: 'uint256',
                name: 'deadline',
                type: 'uint256',
            },
            {
                internalType: 'uint8',
                name: 'v',
                type: 'uint8',
            },
            {
                internalType: 'bytes32',
                name: 'r',
                type: 'bytes32',
            },
            {
                internalType: 'bytes32',
                name: 's',
                type: 'bytes32',
            },
        ],
        name: 'selfPermit',
        outputs: [],
        stateMutability: 'payable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'token',
                type: 'address',
            },
            {
                internalType: 'uint256',
                name: 'nonce',
                type: 'uint256',
            },
            {
                internalType: 'uint256',
                name: 'expiry',
                type: 'uint256',
            },
            {
                internalType: 'uint8',
                name: 'v',
                type: 'uint8',
            },
            {
                internalType: 'bytes32',
                name: 'r',
                type: 'bytes32',
            },
            {
                internalType: 'bytes32',
                name: 's',
                type: 'bytes32',
            },
        ],
        name: 'selfPermitAllowed',
        outputs: [],
        stateMutability: 'payable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'token',
                type: 'address',
            },
            {
                internalType: 'uint256',
                name: 'nonce',
                type: 'uint256',
            },
            {
                internalType: 'uint256',
                name: 'expiry',
                type: 'uint256',
            },
            {
                internalType: 'uint8',
                name: 'v',
                type: 'uint8',
            },
            {
                internalType: 'bytes32',
                name: 'r',
                type: 'bytes32',
            },
            {
                internalType: 'bytes32',
                name: 's',
                type: 'bytes32',
            },
        ],
        name: 'selfPermitAllowedIfNecessary',
        outputs: [],
        stateMutability: 'payable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'token',
                type: 'address',
            },
            {
                internalType: 'uint256',
                name: 'value',
                type: 'uint256',
            },
            {
                internalType: 'uint256',
                name: 'deadline',
                type: 'uint256',
            },
            {
                internalType: 'uint8',
                name: 'v',
                type: 'uint8',
            },
            {
                internalType: 'bytes32',
                name: 'r',
                type: 'bytes32',
            },
            {
                internalType: 'bytes32',
                name: 's',
                type: 'bytes32',
            },
        ],
        name: 'selfPermitIfNecessary',
        outputs: [],
        stateMutability: 'payable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'token',
                type: 'address',
            },
            {
                internalType: 'address',
                name: 'recipient',
                type: 'address',
            },
            {
                internalType: 'bool',
                name: 'fromBento',
                type: 'bool',
            },
        ],
        name: 'sweep',
        outputs: [],
        stateMutability: 'payable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'recipient',
                type: 'address',
            },
        ],
        name: 'unwrapWETH',
        outputs: [],
        stateMutability: 'payable',
        type: 'function',
    },
    {
        stateMutability: 'payable',
        type: 'receive',
    },
];
//# sourceMappingURL=tridentRouterAbi.js.map